var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_59)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.36 16.3637C31.36 15.2291 31.2582 14.1382 31.0691 13.0909H16V19.28H24.6109C24.24 21.28 23.1127 22.9746 21.4182 24.1091V28.1237H26.5891C29.6145 25.3382 31.36 21.2364 31.36 16.3637Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C20.32 32 23.9418 30.5673 26.5891 28.1236L21.4181 24.1091C19.9854 25.0691 18.1527 25.6363 16 25.6363C11.8327 25.6363 8.30542 22.8218 7.04724 19.04H1.70178V23.1854C4.33451 28.4145 9.74542 32 16 32Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04727 19.04C6.72727 18.08 6.54545 17.0546 6.54545 16C6.54545 14.9455 6.72727 13.92 7.04727 12.96V8.81458H1.70182C0.618182 10.9746 0 13.4182 0 16C0 18.5818 0.618182 21.0255 1.70182 23.1855L7.04727 19.04Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.36364C18.3491 6.36364 20.4581 7.17091 22.1163 8.75636L26.7054 4.16727C23.9345 1.58545 20.3127 0 16 0C9.74542 0 4.33451 3.58545 1.70178 8.81455L7.04724 12.96C8.30542 9.17818 11.8327 6.36364 16 6.36364Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.716b57862e95f005ee6cad0723ed2957.svg";
export { ForwardRef as ReactComponent };